import React from "react";
import {DashboardCell} from "./DashboardCell";

export class DashboardEditableCell extends DashboardCell {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            formattedValue: this.props.formattedValue
        };
        this.handleItemModified = this.handleItemModified.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                value: this.props.value,
                formattedValue: this.props.formattedValue
            });
        }
    }

    handleItemModified(data) {
        this.updateValueOnSubmit(data);
        this.propForOnItemUpdated()(this.props.campaignId, this.props.adgroupId, data);
    }

    render() {
        return (
            <td className={`single-editable-data ${this.processingCssClasses()}`}>
                {this._renderCellInnerContent()}
            </td>
        )
    }

    _renderCellInnerContent() {

        if(!this.shouldRenderCellContent())
            return null;

        return <div className="bu-cell editable">
            <div className="budget-value">{this.renderCellContent()}</div>
            {this.renderEditButton()}
            {this.renderTooltip()}
        </div>;
    }

    renderEditButton() {
        if(this.editionDisabled())
            return <div style={{minWidth:"25px"}}></div>;

        return this.renderEditModal();
    }

    updateValueOnSubmit(data) {
    }

    renderTooltip() {
        return null;
    }

    shouldRenderCellContent() {
        return true;
    }

    editionDisabled() {
        return false
    }

    propForOnItemUpdated() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderCellContent() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderEditModal() {
        throw new Error('This method must be overridden in the concrete component.');
    }
}
